// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthFormContainer_container__V-aus"};